import { Loader2 } from 'lucide-react';

const MenuConfigurationLoading = () => (
  <div className="flex min-h-[420px] flex-col items-center justify-center gap-3 px-6 text-center">
    <span className="rounded-xl bg-primary/10 p-3 text-primary">
      <Loader2 className="h-6 w-6 animate-spin" />
    </span>
    <p className="text-sm font-medium text-bodydark2">
      Cargando configuración del menú...
    </p>
  </div>
);

export default MenuConfigurationLoading;
